import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { MrpPackingOrderCustomContainerSizeContainer } from "../../../../../../models/aggregates/mrp-packing";
import { ApiResponseModel, ApiVisa } from "../../shared";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class PackingListService extends BaseApiTemplateService<MrpPackingOrderCustomContainerSizeContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "gen-doc";
    this.httpClient = http;
  }

  getPackingOrdersByDeliveryOrder(guid: string, visa: ApiVisa): Observable<ApiResponseModel<MrpPackingOrderCustomContainerSizeContainer>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/packing-list-by-delivery-order/backoffice-ep/' + guid;
    }
    return this.httpClient.get<ApiResponseModel<MrpPackingOrderCustomContainerSizeContainer>>(
      url,
      this.getHttpHeader(visa)
    );
  }
}
